import { render } from "./ObjectContextMenuComp.vue?vue&type=template&id=f1a53c40&scoped=true"
import script from "./ObjectContextMenuComp.vue?vue&type=script&lang=js"
export * from "./ObjectContextMenuComp.vue?vue&type=script&lang=js"

import "./ObjectContextMenuComp.vue?vue&type=style&index=0&id=f1a53c40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1a53c40"]])

export default __exports__